
import React from 'react';
import youtubeIcon from '../assets/youtube-96.png';

const SearchResults = ({ onTagClick, responseData }) => {

  return (
    <>
      {responseData.data ? (

        <>        

          {(responseData?.data?.youTubeData?.length > 0 || responseData?.data?.videoData?.length > 0) && (
            <div className='player_videos'>🎥<strong>Player Videos</strong></div>
          )}


          {(responseData?.data?.youTubeData?.length == '' && responseData?.data?.videoData?.length == '' && responseData?.data?.wikiData?.length == '') &&
            <p>🎥 No media to display</p>
          }

          {responseData?.data?.youTubeData?.length > 0  &&
            <div className="youtube-videos">
              {responseData.data.youTubeData.map((video) => (
                <div key={video.id.videoId} className="video-item mb-3 position-relative right-side-bar">
                  <a href={`https://www.youtube.com/watch?v=${video.id.videoId}`} target="_blank" rel="noopener noreferrer">
                    <div className="thumbnail-container">
                      <img src={video.snippet.thumbnails.medium.url} alt={video.snippet.title} className="img-fluid" />
                      <div class="watch-button">Watch
                        <span class="circle-icon">
                          <i class="fa fa-play"></i>
                        </span>
                      </div>
                    </div>

                    <h5 className="mt-2"> <img className='youtube-icon' src={youtubeIcon} alt="YouTube Icon" />  <span
                      dangerouslySetInnerHTML={{ __html: video.snippet.title }}
                    /></h5>
                  </a>
                </div>
              ))}
            </div>
          }

          {responseData?.data?.videoData &&
            <div className="video-data mt-1 goldcleats-videos">
              {responseData.data.videoData.map((video) => (
                <div key={video.video_id} className="video-data-item mb-3 position-relative right-side-bar">
                  <a href={`https://www.goldcleats.com/?type=public&item_id=${video.video_id}&action=34`} target="_blank" rel="noopener noreferrer">
                    <div className="thumbnail-container">
                      <img src={video.image_url} alt={`Video ${video.video_id}`} className="img-fluid" />
                      <div className="watch-button">Watch
                        <span className="circle-icon">
                          <i className="fa fa-play"></i>
                        </span>
                      </div>
                    </div>
                    <h5 className="mt-2"><span className='goldcleats-icon'><img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg"></img></span> <span>GoldCleats Player Profile Video</span></h5>
                   
                  </a>
                </div>
              ))}
            </div>
          }


          {responseData?.data?.wikiData && responseData?.data?.wikiData?.length > 0 &&
            <div className="youtube-videos">
              {responseData.data.wikiData.map((data, index) => (
                <div key={index} className="mb-3 position-relative">
                  <a href={data.wiki_url} target="_blank" rel="noopener noreferrer">
                    <div className="thumbnail-container">
                      <img width={320} src={data.wiki_img} alt="" className="img-fluid player-image" />
                    </div>
                  </a>
                </div>
              ))}
            </div>
          }

        </>


      ) : (
        <p>No media to display</p>
      )}
    </>
  );
};

export default SearchResults;
